import { render } from "./JourneyIdContainer.vue?vue&type=template&id=36f1eaac&scoped=true&lang=html"
import script from "./JourneyIdContainer.vue?vue&type=script&lang=js"
export * from "./JourneyIdContainer.vue?vue&type=script&lang=js"

import "./JourneyIdContainer.vue?vue&type=style&index=0&id=36f1eaac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f1eaac"]])

export default __exports__